import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'core-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})

export class SpinnerComponent implements OnInit {

 
  @Input()
  public message: string;

  constructor() { 
    this.message = 'Please, wait...';
  }

  ngOnInit() {
  }

}
